/*
  A/B Test: [PDP] Product form redesign — VARIANT (B) behavior.
  Loaded only by sections/main-product-form-test.liquid.
  1. Purchase options (subscription vs one-time) sync + variant price updates.
  2. Accordions: one section open at a time.
  3. "Pair it with" ATC: explicit "Adding…" text state (text + spinner, not color).
  Teardown: delete this file with the other pft-* files.
*/
(function () {
  'use strict';

  /* ---------- 1. Purchase options ---------- */

  function initPurchase(root) {
    if (!root || root.dataset.pftInit === 'true') return;
    root.dataset.pftInit = 'true';

    var configEl = root.querySelector('[data-pft-purchase-config]');
    var config = { locale: 'en', currency: 'USD', discountBoxDefault: false };
    try {
      if (configEl) config = Object.assign(config, JSON.parse(configEl.textContent));
    } catch (error) {
      /* keep defaults */
    }

    var subCard = root.querySelector('.pft-card--subscription');
    var onetimeCard = root.querySelector('.pft-card--onetime');
    var subRadio = subCard ? subCard.querySelector('input[type="radio"]') : null;
    var onetimeRadio = onetimeCard ? onetimeCard.querySelector('input[type="radio"]') : null;
    var productId = root.dataset.productId;
    var sectionId = root.dataset.section;
    var form = root.closest('form');
    var applyField = form ? form.querySelector('input[name="properties[_apply_discount]"]') : null;

    function sync() {
      var isSubscription = !!(subRadio && subRadio.checked);

      root.querySelectorAll('select[name="selling_plan"]').forEach(function (el) {
        el.disabled = !isSubscription;
      });
      root.querySelectorAll('.pft-card__plan-select').forEach(function (el) {
        el.classList.toggle('is-disabled', !isSubscription);
      });

      if (subCard) subCard.classList.toggle('is-checked', isSubscription);
      if (onetimeCard) onetimeCard.classList.toggle('is-checked', !isSubscription);

      if (applyField) applyField.value = isSubscription ? 'false' : String(config.discountBoxDefault);
    }

    if (subRadio) subRadio.addEventListener('change', sync);
    if (onetimeRadio) onetimeRadio.addEventListener('change', sync);

    // A click anywhere on the subscription card (except the select) selects it.
    if (subCard && subRadio) {
      subCard.addEventListener('click', function (event) {
        if (event.target.closest('.pft-card__plan-select')) return;
        if (!subRadio.checked) {
          subRadio.checked = true;
          sync();
        }
      });
    }

    document.addEventListener('submit', sync, true);
    sync();

    // Keep prices in step with variant changes. Currency/locale come from
    // Liquid so prices follow the active market.
    if (form) {
      form.addEventListener('variant:change', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;

        var allocation = variant.selling_plan_allocations && variant.selling_plan_allocations[0];
        var format = function (cents) {
          return new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(cents / 100);
        };

        var compareEl = document.getElementById('pft-price-' + sectionId + '-compare');
        var subEl = document.getElementById('pft-price-' + sectionId + '-sub');
        var onetimeEl = document.getElementById('pft-price-' + sectionId + '-onetime');

        if (compareEl && allocation) compareEl.textContent = format(allocation.compare_at_price || variant.price);
        if (subEl && allocation) subEl.textContent = format(allocation.price);
        if (onetimeEl) onetimeEl.textContent = format(variant.price);
      });
    }
  }

  /* ---------- 2. Accordions: one open at a time ---------- */

  function initAccordionGroups() {
    document.querySelectorAll('pft-accordion-group[data-single-open]').forEach(function (group) {
      if (group.dataset.pftInit === 'true') return;
      group.dataset.pftInit = 'true';

      group.addEventListener('openable-element:open', function (event) {
        var opened = event.target;
        if (!opened.matches('collapsible-content')) return;

        group.querySelectorAll('collapsible-content[open]').forEach(function (other) {
          if (other !== opened) other.open = false;
        });
      });
    });
  }

  /* ---------- 3. Pair-it ATC "Adding…" state ---------- */

  function initPairAtc() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form.matches || !form.matches('form')) return;

        var button = form.querySelector('.js-pft-pair-atc');
        if (!button || button.dataset.pftAdding === 'true') return;

        var originalText = button.dataset.originalText || button.textContent.trim();
        button.dataset.originalText = originalText;
        button.dataset.pftAdding = 'true';
        button.setAttribute('aria-disabled', 'true');

        var textNode = button.querySelector('span[ref="textContent"]') || button;
        textNode.textContent = button.dataset.addingText || 'Adding…';

        var restore = function () {
          button.dataset.pftAdding = 'false';
          button.removeAttribute('aria-disabled');
          textNode.textContent = originalText;
          document.removeEventListener('cart:updated', restore);
        };

        document.addEventListener('cart:updated', restore);
        setTimeout(restore, 5000);
      },
      true
    );
  }

  /* ---------- 4. Dev/QA preview of the B group (?pft=b) ----------
     Loads pft-reveal.css — the exact stylesheet the Intelligems variant group
     injects — so the preview can never drift from the live test. */

  function initPreview() {
    if (!/[?&]pft=b\b/.test(window.location.search)) return;
    if (document.querySelector('link[data-pft-reveal]')) return;

    var base = document.querySelector('link[href*="pft-pdp.css"]');
    if (!base) return;

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = base.href.replace('pft-pdp.css', 'pft-reveal.css');
    link.setAttribute('data-pft-reveal', '');
    // Re-measuring the gallery once this lands is initGalleryResync's job — it
    // watches the width, so the same fix covers the injected CSS on live.
    document.head.appendChild(link);
  }

  /* ---------- 5. Rerender bridge ----------
     The theme's <product-rerender> element only observes the CONTROL form.
     The variant form dispatches its own (non-bubbling) product:rerender after
     a variant change; forward it to the control form so prices, pills, and
     buy buttons re-render for both columns (block ids are suffixed with -pft,
     so each column only matches its own blocks in the fetched fragment). */

  function initRerenderBridge() {
    document.querySelectorAll('form[id$="-pft"]').forEach(function (form) {
      if (form.dataset.pftBridge === 'true') return;
      form.dataset.pftBridge = 'true';

      // form.id would return the <input name="id"> element, not the id string.
      var formId = form.getAttribute('id');
      var controlForm = document.getElementById(formId.replace(/-pft$/, ''));
      if (!controlForm) return;

      form.addEventListener('product:rerender', function (event) {
        controlForm.dispatchEvent(new CustomEvent('product:rerender', { detail: event.detail }));
      });
    });
  }

  /* ---------- 6. Gallery re-measure ----------
     Flickity caches every slide's position and the viewport height at init.
     In the B group the reveal CSS arrives on its own schedule — Intelligems
     injects it, or ?pft=b appends pft-reveal.css — and it widens the gallery
     (container to 90rem, .product__media grows into the flex row up to 700px).
     When it lands after Flickity has measured, the cached geometry stays at the
     control width: slide 2 sits inside slide 1's right edge and the viewport
     clips the bottom of both. Watch the gallery's own width and re-measure on
     change, so it self-corrects whenever the CSS shows up. */

  function initGalleryResync() {
    if (typeof ResizeObserver === 'undefined') return;

    document.querySelectorAll('.xt-pdp-page .product__media flickity-carousel').forEach(function (carousel) {
      if (carousel.dataset.pftResync === 'true') return;
      carousel.dataset.pftResync = 'true';

      var lastWidth = null;

      new ResizeObserver(function (entries) {
        var width = Math.round(entries[0].contentRect.width);

        // Height changes are Flickity's own adaptiveHeight writing to the
        // viewport; reacting to those would feed the observer its own output.
        if (width === lastWidth) return;

        var isFirstReading = lastWidth === null;
        lastWidth = width;
        if (isFirstReading) return;

        // Undefined until the custom element upgrades, and single-slide
        // galleries never build one. Nothing to re-measure either way — a
        // Flickity created after this point measures the new width itself.
        var instance = carousel.flickityInstance;
        if (!instance) return;

        Promise.resolve(instance).then(function (flkty) {
          if (flkty && flkty.isActive) flkty.resize();
        });
      }).observe(carousel);
    });
  }

  /* ---------- boot ---------- */

  function init() {
    initPreview();
    document.querySelectorAll('.pft-purchase').forEach(initPurchase);
    initAccordionGroups();
    initPairAtc();
    initRerenderBridge();
    initGalleryResync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The pair-it list arrives async (product recommendations fetch) and the
  // purchase widget can be re-rendered; re-scan when the DOM settles.
  var observer = new MutationObserver(function () {
    document.querySelectorAll('.pft-purchase:not([data-pft-init="true"])').forEach(initPurchase);
    initAccordionGroups();
    initRerenderBridge();
    initGalleryResync();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
